// Shared Tailwind class strings for SeasonTimesPage sub-components.
// Extracting them here avoids duplication across the form, table, and cards
// without creating a dedicated component for each input element.

export const fieldCls =
  'w-full rounded-sm border border-gray-300 px-3 py-1.5 font-body text-sm text-gray-900 ' +
  'outline-none transition-agrobook duration-agrobook ' +
  'focus:border-green-600 focus:ring-4 focus:ring-green-600/15 ' +
  'disabled:bg-gray-50 disabled:text-gray-400';

export const editBtnCls =
  'flex h-8 w-8 items-center justify-center rounded-sm border border-gray-300 bg-white ' +
  'text-gray-500 transition-agrobook duration-agrobook ' +
  'hover:border-green-400 hover:bg-green-100 hover:text-green-800';

export const deleteBtnCls =
  'flex h-8 w-8 items-center justify-center rounded-sm border border-gray-300 bg-white ' +
  'text-gray-500 transition-agrobook duration-agrobook ' +
  'hover:border-red-200 hover:bg-red-50 hover:text-red-600';
